/* eslint-disable no-nested-ternary */
import { ChakraBox } from '@equip.health/ui';

import NoData from '~/components/common/NoData';
import { WeightGoalsListItem } from '~/components/maud/patients/profile/clinical-profile/clinical-measurement/clinical-measurement-modal/key-vitals/KeyVitalsList/weight-goals/WeightGoalsListItem';

type WeightGoalsListProps = {
  filteredGoalsData: PatientWeightGoalType[];
  goalsData: PatientWeightGoalType[];
  patientId: string;
};
const TOP_LEVEL_ID = 'weight-goal-list';

const WeightGoalsList = ({
  filteredGoalsData,
  goalsData,
  patientId,
}: WeightGoalsListProps) => {
  return (
    <ChakraBox>
      {(filteredGoalsData || [])?.length > 0 ? (
        <>
          {filteredGoalsData.map((goal: PatientWeightGoalType) => (
            <WeightGoalsListItem
              goal={goal}
              goalsList={goalsData}
              key={`${TOP_LEVEL_ID}-item__${goal?.observationGoalExternalId}`}
              patientId={patientId}
            />
          ))}
        </>
      ) : (
        <NoData placeholderText="There are no active goals" />
      )}
    </ChakraBox>
  );
};

export default WeightGoalsList;
